import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { inlinePickCss } from "../../atoms/InlinePickTrigger";
import {
  controlSize,
  type ControlSizeKey,
} from "../../../design-system/tokens/controlSizes";

export const Wrap = styled.button<{
  $invalid: boolean;
  $size: ControlSizeKey;
  $muted: boolean;
  $sentence?: boolean;
  $open?: boolean;
}>`
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  width: 100%;
  height: ${({ $size }) => controlSize.field[$size]};
  min-height: ${({ $size }) => controlSize.field[$size]};
  padding: ${spacing[2]} ${spacing[3]};
  background-color: ${rawColors.structural.white};
  border: 1px solid
    ${({ $invalid }) =>
      $invalid ? rawColors.accent.pink : rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    outline: none;
    border-color: ${rawColors.primary[500]};
  }

  ${({ $sentence, $open, $invalid }) =>
    $sentence &&
    css`
      ${inlinePickCss({ open: $open, invalid: $invalid })}
      width: auto;
      flex: none;
      white-space: nowrap;
    `}
`;

export const IconSlot = styled.span<{ $muted: boolean }>`
  display: inline-flex;
  align-items: center;
  color: ${({ $muted }) =>
    $muted ? rawColors.text.lowEmphasis : rawColors.text.mediumEmphasis};
  flex-shrink: 0;
  pointer-events: none;
`;

export const Value = styled.span<{ $placeholder: boolean; $muted: boolean; $sentence?: boolean }>`
  ${typographyMixin("caption", 3)}
  ${({ $sentence }) => $sentence && "font: inherit;"}
  color: ${({ $placeholder, $muted }) =>
    $placeholder || $muted
      ? rawColors.text.lowEmphasis
      : rawColors.text.highEmphasis};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
`;
